import { SimpleGrid } from '@chakra-ui/react'
import { type ElementType, type ReactNode } from 'react'
import { classNames } from '~/utils/helpers'

import Container from '../Container/Container'

export default function ContainerGrid({
  children,
  isFluid,
  width,
  className,
  as,
  ...props
}: {
  children?: ReactNode
  isFluid?: Boolean
  width?: string
  as?: ElementType
  props?: any
  className?: string
}) {
  return (
    <Container
      className={classNames(['container-grid', className])}
      fluid={Boolean(isFluid)}
      {...({ as } as any)}
      width={width ?? 'auto'}
    >
      <SimpleGrid columns={12} spacing={['16px', '32px']} {...props}>
        {children}
      </SimpleGrid>
    </Container>
  )
}
